"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.getValidator = void 0;
var _now = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/date/now"));
const MIN_YEAR = 1900;
const inputsAreBlank = _ref => {
  let {
    year,
    month,
    day
  } = _ref;
  return !(year && month && day);
};
const isValidDate = date => date.getFullYear() > MIN_YEAR && (0, _now.default)() > date.getTime();

/**
 *
 * Validates the input and returns an array of error strings
 * @param {Object} data The data object passed by the date input component to the callback
 * @returns {Array} The error strings
 */
const getValidator = _ref2 => {
  let {
    isRequiredMsg,
    invalidMsg
  } = _ref2;
  return _ref3 => {
    let {
      date,
      year,
      month,
      day,
      errors
    } = _ref3;
    if (inputsAreBlank({
      year,
      month,
      day
    })) {
      return [isRequiredMsg];
    }
    if (!date || !isValidDate(date)) {
      return [invalidMsg];
    }
    return errors;
  };
};
exports.getValidator = getValidator;